import { useState } from "react";
import SectionHead from "./SectionHead";
import { collectionTabs, collections } from "@/mocks/cgua";

export default function Collections() {
  const [active, setActive] = useState("全部专题");
  const list =
    active === "全部专题"
      ? collections
      : collections.filter((c) => c.tag === active);

  return (
    <section id="heji" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHead
          no="03"
          eyebrow="17吃瓜合集"
          title="专题合集 · 想吃哪份翻哪份"
          desc="每份合集都按一条线索收齐相关瓜料，边翻边续，像读一本随时更新的专题册。"
          linkLabel="浏览全部合集"
        />

        {/* 标签切换 */}
        <div className="flex items-center gap-1.5 bg-background-100 border border-background-200 p-1 rounded-full w-fit mb-6 flex-wrap">
          {collectionTabs.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setActive(t)}
              className={
                "px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer " +
                (active === t
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-primary-700")
              }
            >
              {t}
            </button>
          ))}
        </div>

        {/* 大卡小卡混排网格 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {list.map((c, i) => {
            const isBig = i === 0;
            return (
              <article
                key={c.title}
                className={
                  "group rounded-xl border border-background-200 bg-background-100 overflow-hidden hover:border-primary-300 transition-colors flex flex-col " +
                  (isBig ? "sm:col-span-2 lg:col-span-2" : "")
                }
              >
                <div className="relative overflow-hidden">
                  <div className={isBig ? "w-full h-[200px] md:h-[220px]" : "w-full h-[168px] md:h-[184px]"}>
                    <img
                      src={c.cover}
                      alt={`${c.title} 合集封面`}
                      title={`17吃瓜合集 · ${c.title}`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.05]"
                    />
                  </div>
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-foreground-950/75 text-background-50 text-xs font-semibold px-2.5 py-1">
                    {c.tag}
                  </span>
                  <span
                    className={
                      "absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-full text-xs font-bold px-2.5 py-1 " +
                      (c.category === "完结"
                        ? "bg-secondary-200 text-secondary-900"
                        : c.category === "更新中"
                          ? "bg-accent-500 text-foreground-950"
                          : "bg-primary-500 text-background-50")
                    }
                  >
                    {c.category}
                  </span>
                </div>
                <div className="p-4 md:p-5 flex flex-col flex-1">
                  <div className="flex items-center justify-between">
                    <h3 className="text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                      {c.title}
                    </h3>
                    <span className="shrink-0 text-xs font-semibold text-foreground-500">
                      {c.count} 条
                    </span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">
                    {c.desc}
                  </p>
                  <a
                    href="#"
                    className="mt-4 inline-flex items-center gap-1.5 self-start text-sm font-semibold text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
                  >
                    打开这份合集
                    <i className="ri-arrow-right-up-line text-[15px]" />
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}